// Module
var code = `<button
  type="button"
  class="qs-row-main"
  data-event-type="acmeSearch"
  data-btn-type="select-customer"
  data-customer-name="{{attrCustomerName}}"
  title="Show this customer's invoices"
>
  <img
    src="{{attrImageSrc}}"
    class="rounded-full"
    width="24"
    height="24"
    alt="{{attrImageAlt}}"
  />
  <span class="qs-name">{{name}}</span>
  <span class="qs-email">{{email}}</span>
  <span class="qs-meta">View invoices &rarr;</span>
</button>
`;
// Exports
module.exports = code;